import { useCaseLayout } from '../../../shared/user/layout/caseLayout/useCaseLayout';
import { useProgressBarStore } from '../../../../store/hooks/useProgressBarStore';
import { Stages, stagesAcromegaly, stagesCushing, stagesCushingV2 } from './CaseDraft.helper';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useDraftCaseApi } from '../../../../apiHooks';
import { DiseaseType } from '../../../../interfaces/common/common';
import { generateLink, ViewUserLink } from '../../../../utils';
import { RoleFunction } from '../../../../constants/projectUsers';

export const useCaseDraftVm = () => {
  const navigate = useNavigate();
  const [startViewing, setStartViewing] = useState(false);
  const { type, id, version } = useParams();
  const { getDraftCaseFirstStage } = useDraftCaseApi();
  const progressBarStore = useProgressBarStore();
  const { currentStage, isDraft } = progressBarStore;
  const isPrev = !id && Stages.ZERO < currentStage;

  const { filter, handleChange } = useCaseLayout();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentStage]);

  useEffect(() => {
    if (!id || Stages.ZERO < currentStage) {
      setStartViewing(true);
    }
  }, [id, currentStage]);

  useEffect(() => {
    if (isDraft !== null && !isDraft) {
      navigate(
        generateLink(
          RoleFunction.ROLE_VIEWING,
          version === 'v2' ? ViewUserLink.CASE_VIEW_CUSHINGV2 : ViewUserLink.CASE_VIEW,
          version === 'v2'
            ? [
                [':type', type as DiseaseType],
                [':id', Number(id)],
                [':version', version as string]
              ]
            : [
                [':type', type as DiseaseType],
                [':id', Number(id)]
              ]
        )
      );
    }
  }, [isDraft, navigate, type, id, version]);

  useEffect(() => {
    if (progressBarStore.zeroStage === null && id) {
      void getDraftCaseFirstStage(Number(id), type as DiseaseType, false, version);
    }
  }, [progressBarStore, getDraftCaseFirstStage, id, type, version]);

  useEffect(() => {
    return () => progressBarStore.clearStore();
  }, [progressBarStore]);

  const handleReset = () => {
    progressBarStore.resetProgressBar();
  };

  if (isPrev) {
    handleReset();
  }

  function getStageConfig(currentStage: number, isPrev: boolean, type?: string, version?: string) {
    const stageToFind = isPrev ? 0 : currentStage;
    switch (type) {
      case 'acromegaly':
        return stagesAcromegaly.find(el => el.stage === stageToFind);

      case 'cushing':
        switch (version) {
          case 'v2':
            return stagesCushingV2.find(el => el.stage === stageToFind);
          default:
            return stagesCushing.find(el => el.stage === stageToFind);
        }

      default:
        return undefined;
    }
  }
  const stageConfig = getStageConfig(currentStage, isPrev, type, version);

  return {
    component: stageConfig ? stageConfig.component : null,
    name: stageConfig ? stageConfig.name : '',
    stage: stageConfig ? stageConfig.stage : Stages.ZERO,
    isTitle: stageConfig ? stageConfig.isTitle : false,
    filter,
    handleChange,
    handleReset,
    startViewing
  };
};
